import { HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";

const service = function () {
  // assume no refresh needed on first load
  let needToRefresh = false;
  let shaCheckTimer = null;

  const setRevisionStatus = function (incomingRevision: string) {
    if (!incomingRevision) {
      return;
    }
    if (!window["C"].GIT_REVISION) {
      return;
    }
    if (incomingRevision !== window["C"].GIT_REVISION) {
      needToRefresh = true;
      // once the state change success happens and the refresh happens,
      // this will be reset to false by code loading
    }
  };

  async function periodicCheck() {
    // fetch the current sha from any api endpoint
    const res = await HttpPromiseWithEntireResponse({
      method: "GET",
      url: "/_health",
    });
    let incomingRevision = res.headers.get("x-tiz-git-revision");
    if (incomingRevision) {
      setRevisionStatus(incomingRevision);
    }
    checkAndDoHardRefresh();
  }

  const initializePeriodicCheck = function () {
    if (shaCheckTimer) {
      clearInterval(shaCheckTimer);
    }
    shaCheckTimer = setInterval(periodicCheck, 1000 * 60 * 60 * 12);
  };

  const needHardRefresh = function () {
    if (!needToRefresh) {
      return false;
    }

    // check that we have not already reloaded in the 30 min to avoid
    // any looping unpleasantness, hopefully
    let previous = localStorage.getItem("GitRevisionCheckSetNeedToRefresh");
    if (previous) {
      let parsed = JSON.parse(previous);
      if (parsed && parsed.timestamp && new Date().getTime() - parsed.timestamp < 1000 * 60 * 10) {
        return false;
      }
    }
    return true;
  };

  const doHardRefresh = function () {
    localStorage.setItem(
      "GitRevisionCheckSetNeedToRefresh",
      JSON.stringify({
        timestamp: new Date().getTime(),
      })
    );
    window.location.reload();
  };

  const checkAndDoHardRefresh = function () {
    initializePeriodicCheck();
    if (!needHardRefresh()) {
      return;
    }
    doHardRefresh();
  };

  return {
    setRevisionStatus,
    checkAndDoHardRefresh,
    initializePeriodicCheck,
  };
};
const gitRevisionCheck: any = service();
export default gitRevisionCheck;
